module.exports = __webpack_public_path__ + "static/media/banner-verde.2c063d0a.png";